import { createSlice } from '@reduxjs/toolkit'
import { initialState } from './initialState.ts'

const uninstallAppSlice = createSlice({
  name: 'uninstallApp',
  initialState: initialState,
  reducers: {
    openModal: (state) => {
      state.modalOpen = true
    },
    closeModal: (state) => {
      state.modalOpen = false
    }
  }
})

export const uninstallAppActions = uninstallAppSlice.actions
export const { reducer: uninstallAppReducer } = uninstallAppSlice
